export default __webpack_public_path__ + "static/media/landing-olives.c085d04a.jpg";